import {
  validateString,
  validateAccountNumber,
  validateRoutingNumber,
  isExpirationValid,
  validateZipCode,
} from "_assets/js/helpers";

const hasStarted = (field) => {
  if (field !== undefined && field !== null && field !== "") {
    return 1;
  }
  return 0;
};

// Validate credit card number using Luhn algorithm
export const validateCreditCardNumber = (number) => {
  if (!number) return false;

  // Remove all non-digit characters
  const cleanNumber = number.replace(/\D/g, "");

  // Check if it's a valid length (13-19 digits for most cards)
  if (cleanNumber.length < 13 || cleanNumber.length > 19) {
    return false;
  }

  // Luhn algorithm
  let sum = 0;
  let isEven = false;

  // Loop through digits from right to left
  for (let i = cleanNumber.length - 1; i >= 0; i--) {
    let digit = parseInt(cleanNumber.charAt(i));

    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    isEven = !isEven;
  }

  return sum % 10 === 0;
};

// Validate CVV based on card type
export const validateCVV = (cvv, cardType) => {
  if (!cvv) return false;

  const cleanCvv = cvv.replace(/\D/g, "");

  // American Express uses 4-digit CVV, others use 3-digit
  if (cardType === "amex") {
    return cleanCvv.length === 4;
  } else {
    return cleanCvv.length === 3;
  }
};

export const validateCreditCard = (form, cardType) => {
  const isValid = {
    cardNumber: {
      started: hasStarted(form.cardNumber),
      valid: validateCreditCardNumber(form.cardNumber) ? 1 : 0,
    },
    cardName: {
      started: hasStarted(form.cardName),
      valid: validateString(form.cardName) ? 1 : 0,
    },
    cardExpiry: {
      started: hasStarted(form.cardExpiry),
      valid: isExpirationValid(form.cardExpiry) ? 1 : 0,
    },
    cardCvv: {
      started: hasStarted(form.cardCvv),
      valid: validateCVV(form.cardCvv, cardType) ? 1 : 0,
    },
    cardZip: {
      started: hasStarted(form.cardZip),
      valid: validateZipCode(form.cardZip) ? 1 : 0,
    },
  };

  let allValid = true;
  Object.keys(isValid).forEach((key) => {
    if (!isValid[key].valid) allValid = false;
  });
  isValid.allValid = allValid;

  return isValid;
};

export const validateDebitCard = (form, cardType) => {
  // Debit card validation is the same as credit card
  return validateCreditCard(form, cardType);
};

export const validateBankAccount = (form, current) => {
  const isValid = {
    account: {
      started: hasStarted(form.account),
      valid: validateAccountNumber(form.account || "") ? 1 : 0,
    },
    reAccount: {
      started: hasStarted(form.reAccount),
      valid:
        validateAccountNumber(form?.reAccount) &&
        form?.account === form?.reAccount
          ? 1
          : 0,
    },
    bank: {
      started: hasStarted(form.bank),
      valid:
        validateString(form.bank || "") ||
        validateString(current?.plaidBankName || "")
          ? 1
          : 0,
    },
    routing: {
      started: hasStarted(form.routing),
      valid: validateRoutingNumber(form.routing) ? 1 : 0,
    },
  };

  let allValid = true;
  Object.keys(isValid).forEach((key) => {
    if (!isValid[key].valid) allValid = false;
  });
  isValid.allValid = allValid;

  return isValid;
};
